module.exports = __webpack_public_path__ + "static/alum2-2c9a3267615be6ce8a6757a8ccff3f49.png";